export enum FarmDeviceStatus {
	PENDING = 'pending',
	CONNECTED = 'connected',
	DISCONNECTED = 'disconnected',
}
